import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useTranslations } from '../../../locales/useTranslations';

const PowerBiFAQ = () => {
    const { t } = useTranslations();
    return (
        <section className="faq-area ptb-100 bg-color-f4f5fe" >
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-md-12">
                        <div className="faq-accordion">
                            <h2><span>{t('powerBi_faq_title')}</span></h2>
                            <div className="native-accordion">
                                <details open>
                                    <summary>
                                        {t('powerBi_faq_question1')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('powerBi_faq_answer1')}
                                        </p>
                                    </div>
                                </details>
                                <details>
                                    <summary>
                                        {t('powerBi_faq_question2')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('powerBi_faq_answer2')}
                                        </p>
                                    </div>
                                </details>
                                <details>
                                    <summary>
                                        {t('powerBi_faq_question3')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('powerBi_faq_answer3')}
                                        </p>
                                    </div>
                                </details>
                                <details>
                                    <summary>
                                        {t('powerBi_faq_question4')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('powerBi_faq_answer4')}
                                        </p>
                                    </div>
                                </details>
                                <details>
                                    <summary>
                                        {t('powerBi_faq_question5')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('powerBi_faq_answer5')}
                                        </p>
                                    </div>
                                </details>
                                <details>
                                    <summary>
                                        {t('powerBi_faq_question6')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('powerBi_faq_answer6')}
                                        </p>
                                    </div>
                                </details>
                                <details>
                                    <summary>
                                        {t('powerBi_faq_question7')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('powerBi_faq_answer7')}
                                        </p>
                                    </div>
                                </details>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5 col-md-12">
                        <div className="faq-image">
                            <Player
                                autoplay
                                loop
                                src="/images/lottie/faq.json"
                                style={{ height: '300px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PowerBiFAQ;